<template>
 <a-tabs defaultActiveKey="1" :activeKey="activeTab" @tabClick="tabClickAction">
    <a-tab-pane key="1" v-if="firstTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{firstTabName}}
      </span>
      <submit-course @submittedCourse='changeActiveTab'/>
    </a-tab-pane>
    <a-tab-pane key="2" v-if="secondTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{secondTabName}}
      </span>
      <a-list itemLayout="horizontal" :dataSource="secondTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
              {{item.title.rendered}}
            </router-link>
          </a-list-item-meta>
          <a-tag color="green">
            Submitted Date: {{ item.post_meta.courseSubmissionDateString[0] }}
          </a-tag>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="3" v-if="thirdTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{thirdTabName}}
      </span>
      <a-list itemLayout="horizontal" :dataSource="thirdTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
              {{item.title.rendered}}
            </router-link>
          </a-list-item-meta>
          <a-tag color="green">
            Submitted Date: {{ item.post_meta.courseSubmissionDateString[0] }}
          </a-tag>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="4" v-if="fourthTabDataSource">
      <span slot="tab">
        <a-icon type="file" />
        {{fourthTabName}}
      </span>
      <a-table
        :columns="summaryColumns"
        :rowKey="record => record.course_id"
        :dataSource="fourthTabDataSource"
        >
          <template slot="summary-link" slot-scope="title, reportObj">
            <router-link
              :to="{ name: 'report-summary', params: { 'reportId': reportObj.report_id } }"
            >
              <a-tag color="green">Summary Report </a-tag>
            </router-link>
          </template>

          <router-link
            slot="parent_course_title"
            slot-scope="title, reportObj"
            :to="{ name: 'report-summary', params: { 'reportId': reportObj.report_id } }"
          >
            {{title}}
          </router-link>
        </a-table>
      <!-- <a-list itemLayout="horizontal" :dataSource="fourthTabDataSource">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <router-link
            :to="{ name: 'course-details', params: { courseId: item.id } }"
            slot="title">
              {{item.title.rendered}}
            </router-link>
          </a-list-item-meta>
          <a-tag color="green">
            Submitted Date: {{ item.post_meta.courseSubmissionDateString[0] }}
          </a-tag>
        </a-list-item>
      </a-list> -->
    </a-tab-pane>
  </a-tabs>
</template>
<script>
import submitCourse from '@src/views/pages/Submit-course.vue';

export default {
  name: 'courses-list-tab',
  data() {
    return {
      activeTab: '1',
      summaryColumns: [
        {
          title: 'Course Title',
          dataIndex: 'parent_course_title',
          sorter: false,
          scopedSlots: { customRender: 'parent_course_title' },
        },
        {
          title: 'First Reviewer Name',
          dataIndex: 'first_reviewer_name',
        },
        {
          title: 'Second Reviewer Name',
          dataIndex: 'second_reviewer_name',
        },
        {
          title: 'Completed Date',
          dataIndex: 'completion_date',
          sorter: false,
          scopedSlots: { customRender: 'completion_date' },
        },
        {
          title: '',
          dataIndex: 'summery-link',
          sorter: false,
          scopedSlots: { customRender: 'summery-link' },
        },
      ],
    };
  },
  components: {
    submitCourse,
  },
  props: [
    'firstTabName',
    'firstTabDataSource',
    'secondTabName',
    'secondTabDataSource',
    'thirdTabName',
    'thirdTabDataSource',
    'fourthTabName',
    'fourthTabDataSource',
    'userRole',
  ],
  created() {
  },
  methods: {
    changeActiveTab() {
      this.activeTab = '2';
    },
    tabClickAction(tabKey) {
      this.activeTab = tabKey;
    },
  },
};
</script>
